import React from "react";
import { motion } from "framer-motion";
import { useContent } from "../context/ContentContext";
import { resolveImage } from "../lib/api";
import { Reveal } from "../components/Reveal";
import RichText from "../components/RichText";
import RSVPForm from "../components/RSVPForm";

const RSVP = () => {
  const { content } = useContent();
  const r = content?.rsvp || {};

  return (
    <div data-testid="rsvp-page">
      <section className="relative h-[55vh] min-h-[380px] overflow-hidden">
        <motion.img
          initial={{ scale: 1.12 }} animate={{ scale: 1 }} transition={{ duration: 1.6, ease: [0.22, 1, 0.36, 1] }}
          src={resolveImage(r.heroImageUrl)}
          alt="RSVP"
          className="absolute inset-0 w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-navy/40" />
        <div className="absolute inset-0 flex items-center justify-center text-center px-6">
          <Reveal>
            <span className="uppercase tracking-[0.3em] text-xs text-blush font-bold">RSVP</span>
            <h1 className="font-serif text-5xl md:text-7xl text-white mt-3 tracking-tight">{r.title}</h1>
          </Reveal>
        </div>
      </section>

      <section className="py-24 md:py-32">
        <div className="max-w-2xl mx-auto px-6">
          <Reveal className="text-center mb-12">
            <RichText html={r.introHtml} className="text-lg text-navy" />
          </Reveal>
          <Reveal delay={0.1}>
            <RSVPForm />
          </Reveal>
        </div>
      </section>
    </div>
  );
};

export default RSVP;
